import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Facebook({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 17 17"
    >
      <Path
        d="M3.67344 16.4565L3.65063 9.49585H0.66748V6.5127H3.65063V4.52393C3.65063 1.83988 5.31276 0.546387 7.70711 0.546387C8.85402 0.546387 9.83975 0.631775 10.127 0.669939V3.47492L8.4664 3.47568C7.16422 3.47568 6.91209 4.09445 6.91209 5.00246V6.5127H10.6113L9.61694 9.49585H6.91208V16.4565H3.67344Z"
        fill={iconColor}
      />
    </Svg>
  );
}
